import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitThanetCouncilForms } from "../../redux/actions/thanetCouncilActions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const QuestionsStage1Form = ({ appData, submitThanetCouncilFormsFunc }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    workedForCouncil: {
      key: "workedForCouncil",
      title: "Have you worked for Thanet District Council before?",
      value: getVal("workedForCouncil"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    workedForHRGO: {
      key: "workedForHRGO",
      title: "Have you worked for HRGO?",
      value: getVal("workedForHRGO"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    daysUnableToWork: {
      key: "daysUnableToWork",
      title:
        "Do you have any days you are unable to work due to prior commitments?",
      value: getVal("daysUnableToWork"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    daysUnableToWorkAnswer: {
      key: "daysUnableToWorkAnswer",
      type: "text",
      title: "If yes please state",
      value: getVal("daysUnableToWorkAnswer"),
      mandatory: true,
      dependOn: [{ fieldKey: "daysUnableToWork" }],
    },
    experienceOutdoors: {
      key: "experienceOutdoors",
      title: "Do you have experience working outdoors?",
      value: getVal("experienceOutdoors"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    experienceOutdoorsAnswer: {
      key: "experienceOutdoorsAnswer",
      type: "text",
      title: "If yes, please state doing what and for how long",
      value: getVal("experienceOutdoorsAnswer"),
      mandatory: true,
      dependOn: [{ fieldKey: "experienceOutdoors" }],
    },
    noticeRequired: {
      key: "noticeRequired",
      title: "Do you have to give notice?",
      value: getVal("noticeRequired"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    noticeRequiredAnswer: {
      key: "noticeRequiredAnswer",
      type: "text",
      title: "If yes, please state for how long (weeks/month)",
      value: getVal("noticeRequiredAnswer"),
      mandatory: true,
      dependOn: [{ fieldKey: "noticeRequired" }],
    },
    liveFarFromDepot: {
      key: "liveFarFromDepot",
      type: "number",
      title:
        "How far from the depot do you live ( Half Mile Ride, Manston, CT9 4LX ) in miles?",
      value: getVal("liveFarFromDepot"),
      mandatory: true,
    },
    travelToWork: {
      key: "travelToWork",
      type: "text",
      title:
        "How do you plan to travel to work? ( public transport not available )",
      value: getVal("travelToWork"),
      mandatory: true,
    },
    yourWeight: {
      key: "yourWeight",
      type: "text",
      title:
        "Due to vehicle weight restrictions please confirm your weight in stone and pounds.",
      value: getVal("yourWeight"),
      mandatory: true,
    },
    medicalReasons: {
      key: "medicalReasons",
      title:
        "Do you have any medical reasons that may affect you walking approximately 18 miles per day?",
      value: getVal("medicalReasons"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    medicalReasonsAnswer: {
      key: "medicalReasonsAnswer",
      type: "text",
      title: "If yes, please state",
      value: getVal("medicalReasonsAnswer"),
      mandatory: true,
      dependOn: [{ fieldKey: "medicalReasons" }],
    },
    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.thanetCouncilOnboarding && appData.thanetCouncilOnboarding.YTDO;

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitThanetCouncilFormsFunc(
      "onboardingQuestionsStage1",
      {
        ...fieldValuesPayload,
        date: moment().toISOString(),
      },
      "YTDO"
    );
    history.push("/profile/edit/thanet-council-onboarding");
  };

  const redirectBack = () => {
    history.push("/profile/edit/thanet-council-onboarding");
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Onboarding Questions (Stage 1)"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"thanetCouncil"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

QuestionsStage1Form.propTypes = {
  appData: any,
  submitThanetCouncilFormsFunc: func,
};

const mapDispatchToProps = {
  submitThanetCouncilFormsFunc: submitThanetCouncilForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(QuestionsStage1Form);
